import {Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';

@Directive({
    selector: 'form, [formGroup], form[formGroup]',
})
export class HubspotTrackingFormDirective implements OnInit, OnDestroy {
    @Input() formGroup;
    @Input() HubSpotTracking = false;

    private hackDiv: HTMLDivElement;

    get form(): HTMLFormElement {
        return <HTMLFormElement>this.el.nativeElement;
    }

    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        if (!this.HubSpotTracking) {
            this.cleanUp(this.form, this.hackDiv);
            this.hackDiv = this.disableTracking(this.form);
        }
    }

    disableTracking(form: HTMLFormElement): HTMLDivElement {
        const div = form.ownerDocument.createElement('div');
        div.classList.add('HubspotCollectedFormsWorkaround');
        // eslint-disable-next-line max-len
        div.innerHTML += `<label for="cc-num" class="hidden">credit card HubspotCollectedFormsWorkaround https://community.hubspot.com/t5/APIs-Integrations/How-to-stop-collected-forms-from-collecting-a-form/m-p/299172#M28102</label>
    <input name="cc-num" class="hidden" required="" value="HubspotCollectedFormsWorkaround" id="cc-num">`;
        form.append(div);
        return div;
    }

    cleanUp(form: HTMLFormElement, div: HTMLDivElement) {
        if (!div || !form) {
            return;
        }
        form.removeChild(div);
    }

    ngOnDestroy(): void {
        this.cleanUp(this.form, this.hackDiv);
    }
}
